<script setup lang="ts">
import { ref, watch } from 'vue'
import { useRoute, type RouteLocationMatched } from 'vue-router'
import router from '@/router'

const route = useRoute()

// 生成数组数据
const breadcrumbData = ref<RouteLocationMatched[]>([])
// 获取可用于展示在面包屑上的路由数据（定义为 meta 里有 title 的就可以）
const getBreadcrumbData = () => {
  breadcrumbData.value = route.matched.filter(
    (item) => item.meta.title && item.meta.title != '首页'
  )
}

// 监听路由变化
watch(
  route,
  () => {
    getBreadcrumbData()
  },
  { immediate: true }
)

// 点击跳转
const onLinkClick = (path: string) => {
  router.push(path)
}
</script>
<template>
  <el-breadcrumb separator="/">
    <transition-group name="breadcrumb">
      <!-- 默认有一个首页 -->
      <el-breadcrumb-item key="/home">
        <span><a class="redirect" @click.prevent="onLinkClick('/')">首页</a></span>
      </el-breadcrumb-item>
      <el-breadcrumb-item v-for="(item, index) in breadcrumbData" :key="item.path">
        <!-- 最后一层，不可点击 -->
        <span v-if="index === breadcrumbData?.length - 1" class="no-redirect">
          {{ item.meta.title }}
        </span>
        <a v-else class="redirect" @click.prevent="onLinkClick(item.path)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>
<style scoped lang="scss">
.redirect {
  @apply font-bold;
}

.no-redirect {
  @apply text-gray-400 font-bold;
}

.breadcrumb-fade-enter-active,
.breadcrumb-fade-leave-active {
  transition:
    opacity 0.2s,
    transform 0.2s;
  position: relative;
  z-index: 1;
}

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all 0.5s;
}

.breadcrumb-enter-from,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-leave-active {
  position: absolute;
}
</style>
